<template>
  <img :src="imagePath" style="width: 100%">
</template>
<script>
export default {
  data() {
    return {
      imageItems: {
        "liangdian": "https://cdn2.carziliao.com/wx/ziliaoliangdian.jpg",
        "liangdian2": "https://cdn2.carziliao.com/wx/ziliaoliangdian-2.jpg"
      }
    }
  },
  computed: {
    imagePath() {
      if (this.$route.query.mode == 'liangdian2') {
        return this.imageItems.liangdian2
      } else {
        return this.imageItems.liangdian
      }
    }
  },
  mounted() {
    if (this.$route.query.title) {
      document.title = this.$route.query.title
    }
  }
}
</script>
